(function () {
  // Récupère le popup
  const modal = document.getElementById("SizeGuideModal");
  if (!modal) return;

  // Tous les liens qui vont vers /pages/guide-des-tailles
  const openLinks = document.querySelectorAll("a[href*='/pages/guide-des-tailles']");

  // Bouton X et fond gris
  const closeBtn = modal.querySelector(".size-guide-modal__close");
  const overlay = modal.querySelector(".size-guide-modal__overlay");

  if (!closeBtn || !overlay || openLinks.length === 0) {
    return;
  }

  // 👉 Ouvrir le popup
  openLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();          // Empêche d’ouvrir la page
      modal.classList.add("active");   // Affiche le popup
      document.documentElement.style.overflow = "hidden"; // Bloque le scroll du fond
    });
  });

  // Fonction de fermeture
  function closeModal() {
    modal.classList.remove("active");
    document.documentElement.style.overflow = ""; // Rétablit le scroll
  }
  // Fermer avec le bouton X
  closeBtn.addEventListener("click", closeModal);

  // Fermer en cliquant sur le fond gris
  overlay.addEventListener("click", closeModal);

  // 👉 Fermer avec le bouton X
 
  // 👉 Fermer en cliquant sur le fond gris
 

  // 👉 Fermer avec la touche Échap
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.classList.contains("active")) {
      closeModal();
    }
  });
})();
